import cartServices from '@services/cartservices'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

export const useAddWishListItemMutation = () => {
  const { mutate: addWishlistItem, isLoading: whishListLoading } = useMutation(
    async (payload: any) => {
      const response = await cartServices.addItemInWishlist(payload)
      return response
    },
    {
      onSuccess: (data) => {
        toast.success('Product added save for later successfully', {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-success',
        })
      },
      onError: (error: any) => {
        toast.error(error?.response?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-error',
        })
      },
    },
  )

  return {
    addWishlistItem,
    whishListLoading,
  }
}
